module.exports = __webpack_public_path__ + "static/001-b94a67cb94468c55857501cd6c45bd03.png";